// extracted by mini-css-extract-plugin
export default {"infoHeader":"InfoHeader_infoHeader__MSIXW"};